export default __webpack_public_path__ + "static/media/CV_Jeral_Pineda.9dab8e4b.pdf";